import { classes } from 'html-classes';

import Icon from '~/components/Icon/Icon';

import type { ReviewGalleryProps } from '../../interfaces';
import { getMediaUrl } from '../../utils';

import styles from './ReviewGallery.module.scss';

const ReviewGallery = ({
  media,
  className,
  onMediaClick,
}: ReviewGalleryProps) => {
  if (!media?.length) {
    return null;
  }

  const handleClick = (index: number) => {
    onMediaClick?.(index);
  };

  return (
    <div className={classes([styles.root, className])}>
      {media.map((item, index) => (
        <div
          key={item.id}
          className={styles.imageWrapper}
          onClick={() => handleClick(index)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleClick(index);
            }
          }}
        >
          {item.mediaType === 'video' ? (
            <div className={styles.videoPlaceholder}>
              <img
                src={item.thumbnailUrl || item.url}
                alt=""
                className={styles.videoThumbnail}
                loading="lazy"
              />
              <div className={styles.playButton}>
                <Icon type="play" size={24} className={styles.playIcon} />
              </div>
            </div>
          ) : (
            <img
              src={getMediaUrl(item)}
              alt=""
              className={styles.image}
              loading="lazy"
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ReviewGallery;
